module.exports = "<p>\n  general-settings works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/general-settings/general-settings.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/general-settings/general-settings.component.html
// module chunks = main